import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { shiftTransferDtoSchema } from "../types";

export const getShiftTransferResponseSchema = z.object({
  data: shiftTransferDtoSchema.optional(),
});
export type GetShiftTransferResponse = z.infer<typeof getShiftTransferResponseSchema>;

export function useGetShiftTransfer(shiftId: string, toWorkerId: string) {
  return useQuery({
    queryFn: async () => {
      const response = await get({
        url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/shifts/${shiftId}/transfers/${toWorkerId}`,
        responseSchema: getShiftTransferResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_SHIFT_TRANSFER_FAILURE,
    },
  });
}
